module.exports = __webpack_public_path__ + "img/graph_4.f204a2c8.png";